export const addEmployeeDefaults = {
  // Basic Information
  name: "",
  arabicName: "",
  email: "",
  phone: "",
  nationalId: "",
  idRegion: "",
  dateOfBirth: "",
  age: "",
  gender: "",
  maritalStatus: "",
  nationality: "",
  religion: "",
  militaryStatus: "",
  // Contact Information
  emergencyPhone: "",
  city: "",
  country: "Egypt",
  address: "",
  arabicAddress: "",
  // Work Information
  department: "",
  position: "",
  laborMode: "",
  workingCompany: "",
  company: "",
  contractCompany: "",
  clientCode: "",
  status: "Active",
  salary: "",
  hiringDate: "",
  transportationAllowances: "",
  variableSalary: "",
  firstLineManagerCode: "",
  firstLineManagerName: "",
  secondLineManagerCode: "",
  secondLineManagerName: "",
  // Working Age
  workingAgeYears: "",
  workingAgeMonths: "",
  // Contract Information
  contractDate: "",
  termOfContract: "",
  contractExpiration: "",
  lastContractDate: "",
  lastContractTerm: "",
  lastContractExpiration: "",
  beRegularDate: "",
  toBeRegular: "",
  periodForBeingRegular: "",
  resignedDate: "",
  resignReasons: "",
  // Education Information
  graduateInstitution: "",
  major: "",
  graduationYear: "",
  // Insurance Information
  insuredBeginningDate: "",
  insuranceStatus: "",
  monthsForInsurance: "",
  insuranceNumber: "",
  insuranceSalary: "",
  medicalInsuranceStage: "",
  medicalNumber: "",
  // HR / Other
  uniformSize: "",
  drivingLicenseDegree: "",
  drivingLicenseExpiry: "",
};